/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DashboardMeasurementDateSelection, IGlobal } from './types';

const initialState: IGlobal = {
  showLoadingProgressBar: false,
  currentCompany: undefined,
  currentMeasurementDateId: undefined,
  currentCompanyMeasurementDateId: undefined,
  currentMeasurementDate: undefined,
};

export const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    updateGlobalState: (state, action: PayloadAction<IGlobal>) => ({ ...state, ...action.payload }),
    selectDashboardCompany: (state, action: PayloadAction<IGlobal['currentCompany']>) => {
      state.currentCompany = action.payload;
      state.currentMeasurementDate = undefined;
      state.currentMeasurementDateId = undefined;
      state.currentCompanyMeasurementDateId = undefined;
    },
    selectDashboardMeasurementDate: (state, action: PayloadAction<DashboardMeasurementDateSelection>) => {
      state.currentMeasurementDate = action.payload.currentMeasurementDate;
      state.currentMeasurementDateId = action.payload.currentMeasurementDateId;
      state.currentCompanyMeasurementDateId = action.payload.currentCompanyMeasurementDateId;
    },
    clearDashboardMeasurementDate: state => {
      state.currentMeasurementDate = undefined;
      state.currentMeasurementDateId = undefined;
      state.currentCompanyMeasurementDateId = undefined;
    },
    showLoadingProgressBar: state => ({
      ...state,
      showLoadingProgressBar: true,
    }),
    hideLoadingProgressBar: state => ({
      ...state,
      showLoadingProgressBar: false,
    }),
  },
});

export const {
  updateGlobalState,
  selectDashboardCompany,
  selectDashboardMeasurementDate,
  clearDashboardMeasurementDate,
  showLoadingProgressBar,
  hideLoadingProgressBar,
} = globalSlice.actions;

export default globalSlice.reducer;
